<template>
  <AltModal
    :open="etat.ouvert"
    :title="etat.titre"
    size="sm"
    @update:open="(o: boolean) => !o && repondre(false)"
  >
    <div class="space-y-3">
      <p class="whitespace-pre-line text-sm text-slate-600 dark:text-alt-dark-muted">
        {{ etat.message }}
      </p>

      <!-- Ce que le geste emporte ou change, nommé. Le liseré porte le niveau à
           lui seul (cf. `.igd-note`) : on lit la forme avant la couleur. -->
      <div
        v-if="etat.details?.length"
        class="rounded-lg border-l-2 px-3 py-2 text-sm"
        :class="
          etat.danger
            ? 'border-amaranth bg-amaranth/5 text-slate-600 dark:text-alt-dark-muted'
            : 'border-steel-azure bg-alice-blue text-slate-600 dark:bg-alt-dark-raised dark:text-alt-dark-muted'
        "
      >
        <p class="mb-1 font-medium" :class="etat.danger ? 'text-amaranth' : 'text-steel-azure dark:text-alt-dark-link'">
          {{ etat.danger ? 'Attention :' : 'Ce que cela change :' }}
        </p>
        <ul class="list-inside list-disc space-y-0.5">
          <li v-for="d in etat.details" :key="d">{{ d }}</li>
        </ul>
      </div>

      <p v-if="etat.repli" class="text-xs text-slate-400">{{ etat.repli }}</p>
    </div>

    <template #footer>
      <AltButton variant="ghost" @click="repondre(false)">Annuler</AltButton>
      <AltButton :variant="etat.danger ? 'danger' : 'primary'" @click="repondre(true)">
        {{ etat.action }}
      </AltButton>
    </template>
  </AltModal>
</template>

<script setup lang="ts">
import { etatConfirmation as etat, repondre } from '@/lib/confirmer';

/**
 * L'HÔTE DES CONFIRMATIONS — monté une seule fois, dans la coquille.
 *
 * FERMER, C'EST REFUSER : la croix, Échap et le clic à côté rendent `false`.
 * Devant une suppression ou un export en paie, le doute retient le geste.
 */
</script>
